import { gql } from '@apollo/client'

/*
 * Mutation to save EncodedAPIKeyWorkspaceIDAndSource
 */
export const ENABLE_CONVOY_APP = gql`
  mutation CreateAppAPIKey($appType: String!, $source: String!, $enableAfterCreation: Boolean!) {
    createAppAPIKey(input: { appType: $appType, source: $source, enableAfterCreation: $enableAfterCreation }) {
      value
    }
  }
`

/*
 * Mutation to save EncodedAPIKeyWorkspaceIDAndSource
 */
export const ENABLE_ORBCOMM_APP = gql`
  mutation CreateAppAPIKey(
    $appType: String!
    $source: String!
    $enableAfterCreation: Boolean!
    $isCronBasedOrEventBased: String!
  ) {
    createAppAPIKey(
      input: {
        appType: $appType
        source: $source
        enableAfterCreation: $enableAfterCreation
        isCronBasedOrEventBased: $isCronBasedOrEventBased
      }
    ) {
      value
    }
  }
`

export const ENABLE_HIGHWAY_APP = gql`
  mutation EnableHighwayApp($accessToken: String!) {
    enableHighwayApp(input: { accessToken: $accessToken }) {
      id
    }
  }
`

export const ENABLE_MY_CARRIER_PORTAL_APP = gql`
  mutation EnableMyCarrierPortalApp(
    $appType: String!
    $username: String!
    $onboardingURL: String!
    $password: String!
  ) {
    enableMyCarrierPortalApp(
      input: { appType: $appType, username: $username, onboardingURL: $onboardingURL, password: $password }
    ) {
      id
    }
  }
`

export const ENABLE_RMIS_APP = gql`
  mutation EnableRMISApp($appType: String!, $clientID: String!, $domainName: String, $password: String!) {
    enableRMISApp(input: { appType: $appType, clientID: $clientID, domainName: $domainName, password: $password }) {
      id
    }
  }
`

export const ENABLE_CARGO_CHIEF_APP = gql`
  mutation EnableCargoChiefApp($appType: String!, $clientID: String, $clientSecret: String) {
    enableCargoChiefApp(input: { appType: $appType, clientID: $clientID, clientSecret: $clientSecret }) {
      id
    }
  }
`

export const ENABLE_GREENSCREENS_APP = gql`
  mutation EnableGreenscreensApp($appType: String!, $clientID: String, $clientSecret: String) {
    enableGreenscreensApp(input: { appType: $appType, clientID: $clientID, clientSecret: $clientSecret }) {
      id
    }
  }
`

export const ENABLE_SONAR_APP = gql`
  mutation EnableSonarApp($appType: String!, $username: String!, $password: String!) {
    enableSonarApp(input: { appType: $appType, username: $username, password: $password }) {
      id
    }
  }
`

export const ENABLE_MY_LOGS_APP = gql`
  mutation EnableMyLogsApp($appType: String!, $username: String!, $password: String!) {
    enableMyLogsApp(input: { appType: $appType, username: $username, password: $password }) {
      appEnabled
    }
  }
`

export const ENABLE_QUALITY_LOGS_APP = gql`
  mutation EnableQualityLogsApp($appType: String!, $username: String!, $password: String!) {
    enableQualityLogsApp(input: { appType: $appType, username: $username, password: $password }) {
      appEnabled
    }
  }
`

export const ENABLE_TRUCKX_APP = gql`
  mutation EnableTruckXApp($appType: String!, $dotNumber: String!) {
    enableTruckXApp(input: { appType: $appType, dotNumber: $dotNumber }) {
      appEnabled
    }
  }
`

export const ENABLE_HOS247_APP = gql`
  mutation EnableHos247App($appType: String!, $companyID: String!) {
    enableHos247App(input: { appType: $appType, companyID: $companyID }) {
      appEnabled
    }
  }
`

export const ENABLE_TAI_TMS_APP = gql`
  mutation EnableTaiTMSApp($appType: String!, $apiKey: String!) {
    enableTaiTMSApp(input: { appType: $appType, apiKey: $apiKey }) {
      value
    }
  }
`

export const CREATE_APP_API_KEY = gql`
  mutation CreateAppAPIKey($appType: String!, $source: String, $enableAfterCreation: Boolean!) {
    createAppAPIKey(input: { appType: $appType, source: $source, enableAfterCreation: $enableAfterCreation }) {
      value
    }
  }
`

export const SAVE_CLIENT_DETAILS = gql`
  mutation SaveClientDetails($appType: String!) {
    saveClientDetails(input: { appType: $appType }) {
      id
    }
  }
`

export const SAVE_STATE_PARAM = gql`
  mutation SaveStateParam($id: ID!, $appType: String!) {
    saveStateParam(input: { id: $id, appType: $appType }) {
      id
    }
  }
`

export const ENABLE_PROJECT44_APP = gql`
  mutation EnableProject44App($appType: String!) {
    enableProject44App(input: { appType: $appType }) {
      id
    }
  }
`

export const SAVE_PROJECT44_CREDENTIALS = gql`
  mutation SaveProject44AppCredentials($appType: String!, $encodedUsernamePassword: String!) {
    saveProject44AppCredentials(input: { appType: $appType, encodedUsernamePassword: $encodedUsernamePassword }) {
      id
    }
  }
`

export const ENABLE_FOUR_KITES_CARRIER_APP = gql`
  mutation EnableFourKitesCarrierApp(
    $appType: String!
    $apiKey: String!
    $customers: [FreightVisibilityAppCustomerDTO!]
  ) {
    enableFourKitesCarrierApp(input: { appType: $appType, apiKey: $apiKey, customers: $customers }) {
      id
    }
  }
`

export const ENABLE_PROJECT44_CARRIER_APP = gql`
  mutation EnableProject44CarrierApp(
    $appType: String!
    $username: String!
    $password: String!
    $customers: [Project44CarrierDTO!]!
  ) {
    enableProject44CarrierApp(
      input: { appType: $appType, username: $username, password: $password, customers: $customers }
    ) {
      id
    }
  }
`

export const UPDATE_FOUR_KITES_APP = gql`
  mutation UpdateCustomersInFourKitesCarrier($apiKey: String!, $appType: String!, $updates: Updates) {
    updateCustomersInFourKitesCarrier(input: { appType: $appType, apiKey: $apiKey, updates: $updates }) {
      id
    }
  }
`

export const ENABLE_TRUCKER_TOOLS_CARRIER_APP = gql`
  mutation EnableTruckerToolsCarrierApp(
    $appType: String!
    $carriers: [TruckerToolsCarrierDTO!]
    $clientID: String!
    $clientSecret: String!
  ) {
    enableTruckerToolsCarrierApp(
      input: { appType: $appType, carriers: $carriers, clientID: $clientID, clientSecret: $clientSecret }
    ) {
      id
    }
  }
`

export const UPDATE_TRUCKER_TOOLS_CARRIER_APP = gql`
  mutation UpdateCarriersInTruckerToolsCarrier($appType: String!, $updates: TruckerToolsCarrierUpdates!) {
    updateCarriersInTruckerToolsCarrier(input: { appType: $appType, updates: $updates }) {
      id
    }
  }
`

export const ENABLE_TRANSPOREON_APP = gql`
  mutation EnableTransporeonApp(
    $appType: String!
    $username: String!
    $password: String!
    $customers: [FreightVisibilityAppCustomerDTO!]
  ) {
    enableTransporeonApp(
      input: { appType: $appType, username: $username, password: $password, customers: $customers }
    ) {
      id
    }
  }
`

export const UPDATE_TRANSPOREON_APP = gql`
  mutation UpdateCustomersInTransporeon($username: String!, $password: String!, $appType: String!, $updates: Updates) {
    updateCustomersInTransporeon(
      input: { appType: $appType, username: $username, password: $password, updates: $updates }
    ) {
      id
    }
  }
`

export const ENABLE_MCLEOD_APP = gql`
  mutation EnableMcLeodApp(
    $companyID: String!
    $mcLeodInstanceURL: String!
    $mcLeodVersion: Float!
    $mcLeodServerTimezone: String!
    $username: String!
    $password: String!
  ) {
    enableMcLeodApp(
      input: {
        companyID: $companyID
        mcLeodVersion: $mcLeodVersion
        mcLeodInstanceURL: $mcLeodInstanceURL
        mcLeodServerTimezone: $mcLeodServerTimezone
        username: $username
        password: $password
      }
    ) {
      externalWorkspaceID
    }
  }
`

export const REQUEST_TMS_LOAD_SYNC = gql`
  mutation RequestTMSLoadSync($appType: String!) {
    requestTMSLoadSync(input: { appType: $appType }) {
      id
    }
  }
`

export const ENABLE_FLEET_LOCATE_APP = gql`
  mutation EnableFleetLocateApp($appType: String!, $apiKey: String!, $username: String!, $password: String!) {
    enableFleetLocateApp(input: { appType: $appType, apiKey: $apiKey, username: $username, password: $password }) {
      appEnabled
    }
  }
`

export const ENABLE_CORETEX_APP = gql`
  mutation EnableCoretexApp($appType: String!, $apiKey: String!, $username: String!, $password: String!) {
    enableCoretexApp(input: { appType: $appType, apiKey: $apiKey, username: $username, password: $password }) {
      appEnabled
    }
  }
`

export const ENABLE_HIRSCHBACH_APP = gql`
  mutation EnableHirschbachApp($appType: String!, $apiKey: String!, $apiURL: String!) {
    enableHirschbachApp(input: { appType: $appType, apiKey: $apiKey, apiURL: $apiURL }) {
      appEnabled
    }
  }
`

export const ENABLE_GPS_INSIGHT_APP = gql`
  mutation EnableGPSInsightApp($appType: String!, $username: String!, $password: String!) {
    enableGPSInsightApp(input: { appType: $appType, username: $username, password: $password }) {
      appEnabled
    }
  }
`

export const ENABLE_GEO_TAB_APP = gql`
  mutation EnableGeoTabApp($appType: String!, $username: String!, $databaseName: String!, $password: String!) {
    enableGeoTabApp(
      input: { appType: $appType, username: $username, databaseName: $databaseName, password: $password }
    ) {
      appEnabled
    }
  }
`

export const ENABLE_ATT_FLEET_MANAGEMENT_APP = gql`
  mutation EnableATTFleetManagementApp(
    $appType: String!
    $username: String!
    $databaseName: String!
    $password: String!
  ) {
    enableATTFleetManagementApp(
      input: { appType: $appType, username: $username, databaseName: $databaseName, password: $password }
    ) {
      appEnabled
    }
  }
`

export const ENABLE_ONE_NETWORK_APP = gql`
  mutation EnableOneNetworkApp(
    $appType: String!
    $orgName: String!
    $serverPath: String!
    $password: String!
    $username: String!
  ) {
    enableOneNetworkApp(
      input: { appType: $appType, orgName: $orgName, serverPath: $serverPath, password: $password, username: $username }
    ) {
      appEnabled
    }
  }
`

export const ENABLE_TQL_TRAX_APP = gql`
  mutation EnableTQLTraxApp(
    $appType: String!
    $clientID: String!
    $ocpApimSubscriptionKey: String!
    $password: String!
    $username: String!
  ) {
    enableTQLTraxApp(
      input: {
        appType: $appType
        clientID: $clientID
        ocpApimSubscriptionKey: $ocpApimSubscriptionKey
        password: $password
        username: $username
      }
    ) {
      appEnabled
    }
  }
`

export const ENABLE_BIG_ROAD_APP = gql`
  mutation EnableBigRoadApp($appType: String!, $apiKey: String!) {
    enableBigRoadApp(input: { appType: $appType, apiKey: $apiKey }) {
      appEnabled
    }
  }
`

export const ENABLE_BLUEINKTECH_APP = gql`
  mutation EnableBlueInkTechApp($appType: String!, $apiKey: String!) {
    enableBlueInkTechApp(input: { appType: $appType, apiKey: $apiKey }) {
      appEnabled
    }
  }
`

export const ENABLE_EMAIL_RATE_CONFIRMATION = gql`
  mutation EnableEmailRateConfirmationApp($appType: String!, $allowedEmailAddresses: [String!]) {
    enableEmailRateConfirmationApp(input: { appType: $appType, allowedEmailAddresses: $allowedEmailAddresses }) {
      rateConfirmationEmail
    }
  }
`

export const ENABLE_TIVE_APP = gql`
  mutation EnableTiveApp($appType: String!, $clientID: String!, $clientSecret: String!) {
    enableTiveApp(input: { appType: $appType, clientID: $clientID, clientSecret: $clientSecret }) {
      appEnabled
    }
  }
`

export const ENABLE_ISAAC_APP = gql`
  mutation EnableISAACApp(
    $appType: String!
    $apiKey: String!
    $username: String!
    $password: String!
    $portalServerNumber: String!
  ) {
    enableISAACApp(
      input: {
        appType: $appType
        apiKey: $apiKey
        username: $username
        password: $password
        portalServerNumber: $portalServerNumber
      }
    ) {
      appEnabled
    }
  }
`

export const ENABLE_US1_NETWORK_TMS_APP = gql`
  mutation EnableUS1NetworkTMSApp($tmsURL: String!, $username: String!, $password: String!) {
    enableUS1NetworkTMSApp(input: { tmsURL: $tmsURL, username: $username, password: $password }) {
      appEnabled
      password
      tmsURL
      username
    }
  }
`

export const DISABLE_APP = gql`
  mutation DisableApp($appType: String!) {
    disableApp(input: { appType: $appType }) {
      id
    }
  }
`

export const UPDATE_EMAIL_RATE_CONFIRMATION = gql`
  mutation UpdateEmailRateConfirmationApp($appType: String!, $allowedEmailAddresses: [String!]) {
    updateEmailRateConfirmationApp(input: { appType: $appType, allowedEmailAddresses: $allowedEmailAddresses }) {
      rateConfirmationEmail
    }
  }
`
export const ENABLE_ELD88_APP = gql`
  mutation EnableELD88App($appType: String!, $apiKey: String!) {
    enableELD88App(input: { appType: $appType, apiKey: $apiKey }) {
      appEnabled
    }
  }
`

export const ENABLE_EROAD_APP = gql`
  mutation EnableERoadApp($appType: String!, $apiKey: String!) {
    enableERoadApp(input: { appType: $appType, apiKey: $apiKey }) {
      appEnabled
    }
  }
`

export const ENABLE_EZLOGZ_APP = gql`
  mutation EnableEzlogzApp($appType: String!, $apiKey: String!) {
    enableEzlogzApp(input: { appType: $appType, apiKey: $apiKey }) {
      appEnabled
    }
  }
`

export const ENABLE_FMELD_APP = gql`
  mutation EnableFMELDApp($appType: String!, $apiKey: String!) {
    enableFMELDApp(input: { appType: $appType, apiKey: $apiKey }) {
      appEnabled
    }
  }
`

export const ENABLE_ELDMANDATE_APP = gql`
  mutation EnableEldMandateApp($appType: String!, $apiKey: String!) {
    enableEldMandateApp(input: { appType: $appType, apiKey: $apiKey }) {
      appEnabled
    }
  }
`
export const ENABLE_ELDPEAK_APP = gql`
  mutation EnableEldPeakApp($appType: String!, $apiKey: String!) {
    enableEldPeakApp(input: { appType: $appType, apiKey: $apiKey }) {
      appEnabled
    }
  }
`

export const ENABLE_VERIZON_TELOGIS_APP = gql`
  mutation EnableVerizonTelogisApp($appType: String!, $username: String!, $password: String!) {
    enableVerizonTelogisApp(input: { appType: $appType, username: $username, password: $password }) {
      appEnabled
    }
  }
`

export const ENABLE_VERIZON_REVEAL_APP = gql`
  mutation EnableVerizonRevealApp($appType: String!, $username: String!, $password: String!) {
    enableVerizonRevealApp(input: { appType: $appType, username: $username, password: $password }) {
      appEnabled
    }
  }
`

export const ENABLE_TURVO_APP = gql`
  mutation EnableTurvoApp(
    $appType: String!
    $username: String!
    $password: String!
    $apiKey: String!
    $clientID: String!
    $clientSecret: String!
  ) {
    enableTurvoApp(
      input: {
        appType: $appType
        username: $username
        password: $password
        apiKey: $apiKey
        clientID: $clientID
        clientSecret: $clientSecret
      }
    ) {
      appEnabled
    }
  }
`

export const ENABLE_ONE_STEP_GPS_APP = gql`
  mutation EnableOneStepGPSApp($appType: String!, $apiKey: String!) {
    enableOneStepGPSApp(input: { appType: $appType, apiKey: $apiKey }) {
      appEnabled
    }
  }
`

export const ENABLE_HUTCH_APP = gql`
  mutation EnableHutchApp($appType: String!, $apiKey: String!) {
    enableHutchApp(input: { appType: $appType, apiKey: $apiKey }) {
      appEnabled
    }
  }
`

export const ENABLE_SUNNYBROOK_APP = gql`
  mutation EnableSunnybrookApp($appType: String!, $apiKey: String!, $apiURL: String!) {
    enableSunnybrookApp(input: { appType: $appType, apiKey: $apiKey, apiURL: $apiURL }) {
      appEnabled
    }
  }
`

export const ENABLE_INFIOS_APP = gql`
  mutation EnableInfiosApp($appType: String!, $username: String!, $password: String!, $receiverID: String!) {
    enableInfiosApp(input: { appType: $appType, username: $username, password: $password, receiverID: $receiverID }) {
      appEnabled
    }
  }
`

export const ENABLE_MONDO_TRACKING_APP = gql`
  mutation EnableMondoTrackingApp($apiKey: String!, $appType: String!) {
    enableMondoTrackingApp(input: { apiKey: $apiKey, appType: $appType }) {
      appEnabled
    }
  }
`

export const ENABLE_APOLLO_ELD_APP = gql`
  mutation EnableApolloELDApp($apiKey: String!, $appType: String!) {
    enableApolloELDApp(input: { apiKey: $apiKey, appType: $appType }) {
      appEnabled
    }
  }
`

export const ENABLE_SUPERXELD_APP = gql`
  mutation EnableSuperXELDApp($apiKey: String!, $appType: String!) {
    enableSuperXELDApp(input: { apiKey: $apiKey, appType: $appType }) {
      appEnabled
    }
  }
`

export const ENABLE_CLONE_OPS_APP = gql`
  mutation EnableCloneOpsApp($apiKey: String!, $appType: String!, $cloneOpsAccountID: String!) {
    enableCloneOpsApp(input: { apiKey: $apiKey, appType: $appType, cloneOpsAccountID: $cloneOpsAccountID }) {
      appEnabled
    }
  }
`

export const ENABLE_EXPEDITE_ALL_BOOKING_APP = gql`
  mutation EnableExpediteAllBookingApp($appType: String!, $clientID: String!, $clientSecret: String!) {
    enableExpediteAllBookingApp(input: { appType: $appType, clientID: $clientID, clientSecret: $clientSecret }) {
      appEnabled
    }
  }
`

export const ENABLE_EXPEDITE_ALL_TRACKING_APP = gql`
  mutation EnableExpediteAllTrackingApp(
    $appType: String!
    $authUsername: String!
    $authPassword: String!
    $shipmentID: String!
    $customerID: String!
  ) {
    enableExpediteAllTrackingApp(
      input: {
        appType: $appType
        authUsername: $authUsername
        authPassword: $authPassword
        shipmentID: $shipmentID
        customerID: $customerID
      }
    ) {
      appEnabled
    }
  }
`

export const ENABLE_THREE_GTMS_APP = gql`
  mutation EnableThreeGTMSApp(
    $action: ThreeGTMSAppActionEnum!
    $appType: String!
    $host: String
    $password: String
    $port: Int
    $username: String
  ) {
    enableThreeGTMSApp(
      input: { action: $action, appType: $appType, host: $host, password: $password, port: $port, username: $username }
    ) {
      appEnabled
      chaineAPIToken
    }
  }
`

export const ENABLE_THREE_PL_SYSTEMS_APP = gql`
  mutation EnableThreePLSystemsApp(
    $appType: String!
    $baseURL: String!
    $clientID: String
    $clientSecret: String
    $password: String
    $username: String
  ) {
    enableThreePLSystemsApp(
      input: {
        appType: $appType
        baseURL: $baseURL
        clientID: $clientID
        clientSecret: $clientSecret
        password: $password
        username: $username
      }
    ) {
      appEnabled
    }
  }
`
